enum ActionTypes {
    SET_VAULT_ITEMS = 'SET_VAULT_ITEMS',
    SET_VAULT_ITEM = 'SET_VAULT_ITEM',
    SET_SHOULD_SHOW_BADGE = 'SET_SHOULD_SHOW_BADGE',
}

export type ActionType = keyof typeof ActionTypes;

export default ActionTypes;
